import styled from "styled-components";

export const SplashBox = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;

  .logo-img {
    width: 170px;
    border-radius: 0px;
  }
`;
